export const apiFetch = async (url, { method = 'GET', token, data } = {}) => {
  const headers = {
    'Content-Type': 'application/json',
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const response = await fetch(url, {
    method,
    headers,
    body: data ? JSON.stringify(data) : undefined,
  })

  if (response.status === 401) {
    const error = new Error('Unauthorized')
    error.status = 401
    throw error
  }

  if (response.status === 403) {
    const error = new Error('Access denied')
    error.status = 403
    throw error
  }

  if (!response.ok) {
    const error = new Error(`HTTP status ${response.status}`)
    error.status = response.status
    throw error
  }

  return response.json()
}
